// ============================================
// MEDIAS SECTION - Extrait de PropertyForm.jsx
// Étape 1.6: Intégration avec ctx
// Behavior: INCHANGÉ
// ============================================
import React from 'react';

/**
 * Section Médias du formulaire de bien
 * @param {Object} ctx - Contexte partagé
 */
const SHOW_VISITE_VIRTUELLE = false; // Réactivable en 1 ligne (v1.1)

const MediasSection = ({ ctx }) => {
  const {
    formData,
    setFormData,
    handleFileUpload,
    handleFileDelete,
    isUploading
  } = ctx;

  return (
    <div className="space-y-8">
      {/* Modern info header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-pink-500/5 via-rose-500/5 to-red-500/10 border border-white/20 backdrop-blur-sm">
        <div className="absolute inset-0 bg-gradient-to-r from-pink-600/10 to-rose-600/10"></div>
        <div className="relative p-6 flex items-center">
          <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-600 rounded-2xl flex items-center justify-center text-white mr-4 shadow-lg shadow-pink-500/25">
            <i className="bi bi-images text-2xl"></i>
          </div>
          <div>
            <h2 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-pink-600 bg-clip-text text-transparent">
              Médias
            </h2>
            <p className="text-gray-600 font-medium">
              Ajoutez des photos, documents et vidéos
            </p>
          </div>
        </div>
      </div>

      {/* Photos */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Photos</h3>
        <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-pink-400 transition-colors">
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={(e) => handleFileUpload && handleFileUpload('photos', e.target.files)}
            className="hidden"
            id="photos-upload"
          />
          <label htmlFor="photos-upload" className="cursor-pointer">
            <i className="bi bi-cloud-upload text-4xl text-gray-400 mb-3 block"></i>
            <p className="text-gray-600 font-medium">Cliquez ou glissez des photos ici</p>
            <p className="text-gray-400 text-sm mt-1">JPG, PNG, WebP (max 10MB)</p>
          </label>
        </div>
        
        {/* Photos preview */}
        {formData.medias?.photos?.length > 0 && (
          <div className="grid grid-cols-4 gap-4 mt-4">
            {formData.medias.photos.map((photo, index) => (
              <div key={index} className="relative group">
                <img
                  src={photo.url}
                  alt={photo.name}
                  className="w-full h-24 object-cover rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => handleFileDelete && handleFileDelete('photos', index)}
                  className="absolute top-1 right-1 w-6 h-6 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Video URL */}
      <div className="bg-white rounded-2xl p-6 border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Vidéo</h3>
        <input
          type="url"
          value={formData.medias?.video_url || ''}
          onChange={(e) => setFormData(prev => ({
            ...prev,
            medias: { ...prev.medias, video_url: e.target.value }
          }))}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-pink-500"
          placeholder="https://youtube.com/watch?v=..."
        />
      </div>

      {/* Visite virtuelle URL — masquée temporairement (flag SHOW_VISITE_VIRTUELLE) */}
      {SHOW_VISITE_VIRTUELLE && (
        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Visite Virtuelle</h3>
          <input
            type="url"
            value={formData.medias?.visite_virtuelle_url || ''}
            onChange={(e) => setFormData(prev => ({
              ...prev,
              medias: { ...prev.medias, visite_virtuelle_url: e.target.value }
            }))}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-pink-500"
            placeholder="https://matterport.com/..."
          />
        </div>
      )}
    </div>
  );
};

export default MediasSection;
